import { useSelector } from 'react-redux';

const useGetVehicleInfo = () => {
    return useSelector((state) => state.vehicle.vehicle_info);
};

export default useGetVehicleInfo;